import React from 'react'
import AnalyzerDemoData from 'Pages/AnalyzersV2/@tour/DemoData'
import { demoPopoverOpen } from './signals'

// Demo shown by the Virtual Tour when no report is loaded: one row per provider, one column per category
const ROWS = [
	{ name: 'alphacars', prices: [92.30, 98.45, 105.10] },
	{ name: 'peakrentals', prices: [88.75, 95.20, 101.60] },
	{ name: 'eurodrive', prices: [85.40, 91.80, 99.25] },
	{ name: 'horizoncars', prices: [90.15, 96.70, 103.80] },
	{ name: 'swiftfleet', prices: [94.60, 100.35, 108.45] },
]

const COLUMNS = ['economy', 'compact', 'intermediate'].map(label => ({ label }))

export default function BrokersDemoData() {
	return <AnalyzerDemoData
		demoPopoverOpen={demoPopoverOpen}
		firstColumn="Provider"
		columns={COLUMNS}
		rows={ROWS}
		chart={{ title: 'Brokers', type: 'column' }}
		withCategories
	/>
}
